import { FeedRow } from '../../FeedRow'

import type { JSX, ReactNode } from 'react'

type EmptyStateAlignedWithFeedProps = {
  children: ReactNode
}

/** Aligns an empty state with the content column of a Community feed. */
export const EmptyStateAlignedWithFeed = ({
  children,
}: EmptyStateAlignedWithFeedProps): JSX.Element => {
  return <FeedRow>{children}</FeedRow>
}
